const spatialResolutions = {
  irregular: 'Irregular',
  halfDegree: '1/2° X 1/2°',
  quarterDegree: '1/4° X 1/4°',
  twentyFifthDegree: '1/25° X 1/25°',
  fortyEighthDegree: '1/48° X 1/48°',
  fourKm: '4km X 4km',
  twelfthDegree: '1/12° X 1/12°',
  seventyKm: '70km X 70km',
  oneDegree: '1° X 1°',
  nineKm: '9km X 9km',
  twentyFiveKm: '25km X 25km',
};

export default Object.freeze(spatialResolutions);
